import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import VideoRecorder from "react-video-recorder";
import { toast } from "react-toastify";
import { makeid } from "utils";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";

import axios from "axios";
import { getStageScreen, setLoading } from "../../../../../redux";

function VisualVerification({activeHolder}) {
  let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
  API_URL_NEW = API_URL_NEW
    ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
    : "";
  const dispatch = useDispatch();
  const { ApiError } = useSelector((state) => state.visual);
  const { inputLabelColor, inputError } = useSelector((state) => state.theme);
  const [videoBlob, setVideoBlob] = useState(null);
  const [showImgModal, setImgShowModal] = useState({
    show: false,
    data: "",
  });
  // const [videoUrl, setVideoUrl] = useState(null);
  // const [image, setImage] = useState("");
  const [location, setLocation] = useState("");
  const [number, setNumber] = useState({
    num1: "",
    num2: "",
  });
  // const [lat, setLat] = useState("");
  // const [long, setLong] = useState("");
  // const [ipcity, setIpCity] = useState("");
  const [sum, setSum] = useState("");
  const [tempSum, setTempSum] = useState(0);
  const [captchaResult, setCaptchaResult] = useState([]);
  const [captchaIsValid, setCaptchaIsValid] = useState(null);

  

  useEffect(() => {
    reloadCaptcha();
  }, []);

  useEffect(() => {
    const total = number.num1 + number.num2;
    setTempSum(total);
    let random,
      arr = [total, total + 2];
    random = randomArrayShuffle(arr);
    setCaptchaResult(random);
  }, [number]);

  useEffect(() => {
    if (ApiError) {
      setVideoBlob(null);
      setSum(false);
    }
  }, [ApiError]);

  const randomArrayShuffle = (array) => {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  };

  const reloadCaptcha = () => {
    setNumber({
      num1: Math.floor(Math.random() * 2) + 1,
      num2: Math.floor(Math.random() * 2) + 1,
    });
    setCaptchaIsValid("");
  };

  const submitCaptcha = (e) => {
    setSum(e.target.value);
    let parseNum = parseInt(e.target.value);
    if (tempSum === parseNum) {
      setCaptchaIsValid(1);
      handleVerification();
    } else {
      setCaptchaIsValid(0);
    }
  };

  const handleBlob = (blob) => {
    setVideoBlob(blob);
  };

  const getData = async () => {
    try {
      const resp = await fetch("https://geolocation-db.com/json/");
      const json = await resp.json();
      setLocation(json);
    } catch (error) {}
  };

  const visualVerifyCallback = (data) => {
    setImgShowModal({
      show: true,
      data: data.data,
    });
  };

  const handleSubmit = () => {
    // dispatch(onSubmitVisualVerify());
  };

  const handleStopVideo = () => {
    setVideoBlob(null);
    setSum(false);
  };

  //send email or sms link
  const [showLinkToSend , setShowLinkToSend] = useState(false);
  const [isLinkSendLoading, setIsLinkSendLogin] = useState(false);
  let brokerID = window.sessionStorage.getItem("broker_id");
  let isThroughLink = window.sessionStorage.getItem("is_through_link");
  let token = window.sessionStorage.getItem("token");
  let baseURL = window.location.origin.toString();
  //  ./send email or sms link

  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  

    const getApiUrl = () => {
      const portal_domain = window.sessionStorage.getItem("portal_domain");
      let API_URL = "";
      if (portal_domain) {
          API_URL = portal_domain.substring(0, portal_domain.length - 1);
      }
      return API_URL;
  };

  const onSendEmailPress = async () => {
    setIsLinkSendLogin(true);
    const headers = {
      headers: {
        Authorization: `Basic ${token}`,
      },
    };
    const resp = await axios.post(
      `${API_URL}/api/method/kyc_customizations.apis.session.sendsessionstartmail`,
      {},
      headers
    );
    dispatch(getStageScreen());
    setShowLinkToSend(true);
    setIsLinkSendLogin(false);
    console.log(resp);

  }
  const handleCloseImgModal = () => {
    setVideoBlob(null);
    setSum(false);
    setImgShowModal({
      show: false,
      data: null,
    });
    return toast.error("Error: Please upload new video.");
  };


  const handleVerification = async () => {
    if (!videoBlob) {
      toast.error("Error: Please try again.");
      return;
    }
  
    dispatch(setLoading(true));
  
    // Create FormData
    const formData = new FormData();
    formData.append("files", videoBlob, `${makeid(6)}.mp4`);
    formData.append("holder", activeHolder); 
    formData.append("question", `${number.num1} + ${number.num2}`);
    formData.append("answer", tempSum);
    try {
      const response = await axios.post(`${getApiUrl()}/api/method/kyc_customizations.apis.joint_holder.visual_verification.endpoint`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Basic ${token}`,
        }
      });
  
      // Check the response from the server
      if (response.data) {
        // Handle success
        toast.success("Video uploaded successfully");
        // Perform any additional actions on success
      }
      dispatch(getStageScreen());
    } catch (error) {
      // Handle error
      console.error("Upload error", error);
      toast.error("Upload failed, please try again.");
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <div className="col-md-9">
      <Title title="Visual Verification" />
      <Modal show={showLinkToSend}>
        <Modal.Header>
          Send link as email
        </Modal.Header>
        <Modal.Body>
          <small>
          We have sent you an email with link. kindly check your email.
          <br/> <br/>
          Or You can use the below link to share with your other device with camera.
          <br/>
          <br/>
          </small>
          <pre>
            <code>
              {baseURL+'/d/' + brokerID + '/' + token}
            </code>
          </pre>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger"
            onClick={() => setShowLinkToSend(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
      <div className="col-md-12">
        <div
          style={{ background: "rgba(12,171,196, 0.1)", borderRadius: 20 }}
          className="px-5 py-3"
        >
          <div style={{ color: inputLabelColor, fontWeight: "bold" }}>
            Capture Video
          </div>
          <div
            style={{ color: inputLabelColor, fontSize: 12 }}
            className="my-1"
          >
            Ensure that your face is clearly visible in the video. (4 to 5
            seconds of video is fine)
          </div>
          <div
            style={{ color: "#F00", fontSize: 14, fontWeight: "500" }}
            className="mb-2"
          >
            Note: Rotate face 45 degree left and 45 degree right.
          </div>
          <div className="video">
            <VideoRecorder
              replayVideoAutoplayAndLoopOff={true}
              onRecordingComplete={(blob) => {
                handleBlob(blob);
              }}
              onStopReplaying={() => handleStopVideo()}
              timeLimit={10000}
            />
          </div>
          {videoBlob && (
            <div className="mt-2">
              <span className="numbrs" style={{ color: inputLabelColor }}>
                What is {number.num1} + {number.num2} = ?
              </span>
              {captchaResult.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="custom-control custom-radio custom-control-inline mx-1"
                  >
                    <input
                      type="radio"
                      id="radio1"
                      className="form-check-input"
                      value={item}
                      checked={item == sum ? true : false}
                      onChange={submitCaptcha}
                    />{" "}
                    &nbsp;
                    <label className="custom-control-label">{item}</label>
                  </div>
                );
              })}
              {captchaIsValid === 0 ? (
                <div style={{ color: inputError }}>Invalid captcha</div>
              ) : (
                ""
              )}
            </div>
          )}
          {/* {isThroughLink != 'true' &&
            <div className="mt-2" style={{textAlign:"right"}}>
              <button className="btn"
                onClick={() => onSendEmailPress()}
              >
                <small>
                {!isLinkSendLoading ? 'Send link as Email' : 
                  <div className="spinner-border text-dark text-sm" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                }
                </small>
              </button>
            </div>
          } */}
          
        </div>
      </div>
      <Modal show={showImgModal.show} onHide={handleCloseImgModal}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="d-flex align-item-center justify-content-center">
            <img src={showImgModal.data?.url} className="img-fluid" alt="" />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button title="Cancel" handleClick={() => handleCloseImgModal()} />
          <Button title="Submit" handleClick={() => handleSubmit()} />
        </Modal.Footer>
      </Modal>
      <div>
      </div>
    </div>
  );
}

export default VisualVerification;
